import Menu from "../../components/Menu/Menu";
import useStyles from "../../assets/styles/styles";
import { Grid, Typography, Divider, IconButton, CircularProgress, Box } from "@material-ui/core";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import CustomButton from "../../controls/Button/CustomButton";
import { useEffect, useLayoutEffect, useState } from "react";
import MedicalFilters from "../../components/MedicalFilters/MedicalFilters";
import MapContainer from "../../components/MapContainer/MapContainer";
import { useDispatch, useSelector } from "react-redux";
import { cleanModelMedicalRecords, getFiltersValues, getPerfilCompleto } from "../../redux/actions/medicalRecords";
import { getFullData } from "../../redux/actions/personalDataActions";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SelectTypeOfComponent from "../../components/PersonalData/SelectTypeOfComponent";
import { useHistory, useLocation } from "react-router";
import { getLimitPlan } from "../../redux/actions/limitPlansAction";
import { verifyPermission, notAccessToThisModule } from "../../utils/utilsFunctions";
import useTrackPageView from "../../utils/useTrackPageView";

const param = {
  parametroLlamado: ''
};

const MedicalRecord = () => {
  const classes = useStyles();
  const { screen } = useResizeScreen();
  const dispatch = useDispatch();
  const medicalRecord = useSelector((state) => state.cartillaReducer.cartilla);
  const completeProfile = useSelector((state) => state.cartillaReducer.completeProfile);
  const [profileSelected, setProfileSelected] = useState(completeProfile);
  const [maps, setMaps] = useState(false);
  const history = useHistory();
  const { search, state } = useLocation();
  const match = search.match(/type=(.*)/);
  const trackPageView = useTrackPageView("Cartilla");
  const typeURL = match?.[1];
  const [type, setActiveType] = useState(-1);
  const affiliatePlan = useSelector((state) => state.personalDataReducer?.fullData?.afiliado?.planDescripcion);
  const [ hasPermission, setHasPermission ] = useState(false);
  const loadingPermission = useSelector((state) => state.limitPlanReducer.requestInProgress);
  const limitPlanReducer = useSelector((state) => state.limitPlanReducer.allLimitPlanData);
  const [searchAddress, setSearchAddress] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [noResults, setNoResults] = useState(false);


  



  const showMaps = (item, i) => (e) => {
    setProfileFunction(item, setProfileSelected);
    if (maps) {
      setMaps(false);
    } else {
      setMaps(true);
    }
  };


  useEffect(() => {
      if (!state?.fromMap) {
        localStorage.removeItem("modelCartilla");
        localStorage.removeItem("selectedValues");
        localStorage.removeItem("values");
      }
    }, []);
    

  useEffect(() => {
    const cartillaArray = medicalRecord?.cartilla;
    if (!cartillaArray) {
      setFilteredData([]);
      setNoResults(false);
      return;
    }

    const firstSearch = searchAddress.trim().toLowerCase();

    if (firstSearch.length < 3) {
      setFilteredData(cartillaArray);
      setNoResults(false);
      return;
    }


    const results = cartillaArray.filter(item => {
      const domicilio = item.prestadorDomicilio?.toLowerCase() || '';
      const barrio = item.prestadorBarrio?.toLowerCase() || '';

      const direccionCompleta = `${domicilio} ${barrio}`;

      return direccionCompleta.includes(firstSearch);
    });

    setFilteredData(results);
    setNoResults(results.length === 0);

  }, [searchAddress, medicalRecord?.cartilla]); 

  useEffect(() => {
    dispatch(getLimitPlan());
    trackPageView();
  }, []);

  useEffect(() => {
    if (profileSelected !== undefined)
      dispatch(getPerfilCompleto(profileSelected));
  }, [profileSelected]);

  useLayoutEffect(() => {
    verifyPermission(limitPlanReducer, affiliatePlan, "Cartilla", setHasPermission);
  }, [limitPlanReducer, affiliatePlan, hasPermission]);

  useEffect(() => {
    dispatch(getFiltersValues(param));
    let numberPerson = window.localStorage.getItem("numeroPersona");
    if (numberPerson) {
      dispatch(getFullData({ numeroPersona: numberPerson }));
    }

    return (() => {
      window.localStorage.removeItem("modelCartilla");
      window.localStorage.removeItem("selectedValues");
      window.localStorage.removeItem("values");
    });
  }, []);


  useEffect(() => {
    window.onpopstate = (e) => {
      dispatch(cleanModelMedicalRecords());
      if (screen.sWidth <= 768 && type !== -1)
        window.location.href = '/MedicalRecords';
      else
        history.push('/');
    };
  });

  useEffect(() => {
    if (typeURL !== undefined) {
      setActiveType(1);
    }
  }, [typeURL]);

  function permissionToEnter(condition) {
    var resp;
    if(condition) {
        resp = (MobileFilters({ medicalRecord, classes, showMaps, screen, maps, typeURL, history, searchAddress, setSearchAddress,noResults, filteredData}));
    } else {
        resp = (notAccessToThisModule());
    }
    return resp;
  }

  return (
    <>
      <Menu />
      {!maps &&
          (
            loadingPermission  && affiliatePlan?
              <div style={{ display: 'flex', justifyContent: 'center', flex: '0 0 100%', paddingTop: '10px' }}>
                <CircularProgress />
              </div>
            :
              (
                permissionToEnter(hasPermission)
              )
          )
        }

      <SelectTypeOfComponent showMaps={showMaps} maps={maps} filteredData={filteredData}  noResults={noResults}/>
      {filteredData && filteredData?.length > 0 &&
        (
          maps && (
            <>
              <Box className={classes.sectionHeaderCartilla}>
                <IconButton onClick={() => { setMaps(prevState => !prevState); }}>
                  <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>
                <Typography className={classes.titleLabelCartilla} >Cartilla </Typography>
                <Box className={classes.divBtnHeaderCartilla}>
                  <CustomButton
                    typeButton="header"
                    type="submit"
                    title="VER LISTADO"
                    customClass={`${classes.sendButton} ${classes.lightLinearGradient}`}
                    style={{ boxShadow: 'none' }}
                    onClick={() => { setMaps(prevState => !prevState); }}
                  />
                </Box>
              </Box>
              <Divider className={`${classes.formDivider} ${classes.boxDividerCartilla}`} />
              <MapContainer showMaps={showMaps} viewList={true} profileSelected={profileSelected} elevation={0.007}/>
            </>
          )
        )
      }
    </>
  );
};

export default MedicalRecord;

function titleButton(isMaps) {
  return isMaps ? "ver listado" : "ver mapa";
}

function MobileFilters({ medicalRecord, classes, showMaps, screen, isMap, typeURL, history,setSearchAddress }) {
  return (
    <>
      {screen.sWidth < 768 &&
        setHeaderInMobile({ history, classes, typeURL })
      }
      {((typeURL === undefined && screen.sWidth < 768) || (screen.sWidth > 768)) && <MedicalFilters isMobile={false}  setSearchAddress={setSearchAddress} />}
        {(medicalRecord.cartilla?.length || 0) > 0 && !isMap && (
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
            direction={screen.sWidth < 768 ? 'column-reverse' : 'row'}
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {medicalRecord.cartilla?.length > 0 && typeURL !== undefined && (
              <Grid item>
                <CustomButton
                  title={titleButton(isMap)}
                  onClick={showMaps(null, 0)}
                  customClass={`${classes.sendButton} ${classes.lightLinearGradient}`}
                />
              </Grid>
            )}
          </Grid>
        )
      }
    </>
  );
}

function setHeaderInMobile({ history, classes, typeURL }) {
  let response = (
    <Box style={{ padding: '4%' }}>
      <Typography className={classes.txtTitleAppointment} >Cartilla</Typography>
      <Divider className={`${classes.formDivider} ${classes.boxDivider}`} />
    </Box>);
  if (typeURL !== undefined) {
    response = (
      <Box className={classes.txtIconCartilla}>
        <IconButton onClick={returnHomeAppointmentHome(history)}>
          <ArrowBackIcon className={classes.iconFilter} />
        </IconButton>
        <Typography className={classes.txtTitleMobileCartilla}>Cartilla</Typography>
        <Divider className={`${classes.formDivider} ${classes.boxDivider}`} />
      </Box>);
  }

  return response;
}

const returnHomeAppointmentHome = (history) => (e) => {
  history.push('/MedicalRecords', { fromMap: true });
};

function setProfileFunction(item, setProfileSelected) {
  item !== null ? setProfileSelected({ PrestadorNumero: item.prestadorNumero }) : setProfileSelected({});
}
